import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Link } from "@material-ui/core";
import imgfood from "../images/thai-food.jpeg";

const useStyles = makeStyles({
  main: {
    display: "flex",
  },
  text: {
    margin: "auto",
    fontWeight: 900,
    color: "#ffffff",
    textTransform: "uppercase",
    padding: 10,
    borderRadius: 2,
    textShadow: "0 1px 0 #989898",
    letterSpacing: -1,
  },
  container: {
    margin: "auto",
  },
});

const Main = ({ id }) => {
  const classes = useStyles();
  return (
    <div className={`${classes.main} parallax main`} id={id}>
      <div className={classes.container}>
        <Typography variant="h1" component="div" className={classes.text}>
          Sawasdee
        </Typography>
        <Typography variant="h3" component="div" className={classes.text}>
          We are Thai Noodle
        </Typography>
        <div style={{ margin: 20, padding: 20 }}>
          <Typography
            variant="overline"
            display="block"
            style={{ marginBottom: 20, fontSize: "initial" }}
          >
            Are you looking for something good?
          </Typography>
          <Button
            variant="contained"
            style={{
              borderRadius: 1,
              backgroundColor: "white",
              marginBottom: 20,
            }}
            href="/ThaiNoodle_Menu2024.pdf"
          >
            View Menu
          </Button>
          <a
            href="https://www.doordash.com/business/56021/?utm_source=partner-link&utm_medium=website&utm_campaign=56021&utm_content=red-l"
            target="_blank"
            alt="Order Food Delivery with DoorDash"
            title="Order Food Delivery with DoorDash"
            style={{ textDecoration: "none", paddingTop: 20 }}
          >
            <div style={{
                position: "relative",
                width: 289,
                height: 59,
                margin: "0px auto",
                background:
                  "url(https://cdn.doordash.com/media/button/button_red_l.svg)",
                color: "transparent",
              }}
              >
              Order Food Delivery with DoorDash
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Main;
